import styled from 'styled-components';

export const Container = styled.div`
  &.YouractivityWrapper{
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), rgba(234, 244, 252, 0.7);
    backdrop-filter: blur(100px);
    min-height: 100vh;
  }
  &.YouractivityBlocks{
    display: flex;
    justify-content: space-between;
    margin: 0 9%;
  }
  &.LeftActivityBlock{
    //width: 65%;
  }
  &.RightActivityBlock{
    //width: 35%;
  }
  & .SmallWrapper{
    background: #FFFFFF;
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
    border-radius: 8px;
    padding: 16px;
    margin-top: 35px;
  }
  &.SearchCircleResults{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &.ShowingThumbs{
    height: 220px;
    display: flex;
    align-items: center;
  }
  &.ActivityThumbs{
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 140px;
  }
  &.ActivityThumbsUp{
    border-right: 1px solid #BABDBE;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  & img{
    height: 40px;
  }
`

export const Img = styled.img`
`

export const StyledH2 = styled.h2`
  &.ActivityHeader{
    font-family: Manrope, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 135%;
    color: #2C2B48;
    margin-bottom: 15px;
    @media screen and (min-width: 768px) {
      margin-bottom: 25px;
    }
    @media screen and (min-width: 992px) {
      margin-bottom: 45px;
    }
  }
  &.Activities{
    font-family: Manrope, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 154%;
    color: #000000;
    margin: 15px 0;
  }
`;

export const StyledH3 = styled.h3`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 154%;
  display: flex;
  align-items: center;
  color: #263238;
`;

export const StyledH4 = styled.h4`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 45.3333px;
  line-height: 62px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.01em;
  color: #1C62EF;
`;

export const StyledParagraph = styled.p`
  &.SmallWrapperP{
    font-family: OpenSans, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    letter-spacing: 0.25px;
    color: #607D8B;
  }
  &.ActivityThumbsP{
    font-family: Manrope, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 115%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #263238;
  }
`;